import { useState } from "react";
import { CalculadoraCDBInputCard } from "./components/calculadora-cdb-input-card";
import { CDBResponse } from "./utilis/calculo";
import { CalculadoraCDBResponse } from "./components/calculadora-cdb-response";

export default function CalculadoraCDB() {
  const [results, setResults] = useState<CDBResponse | null>(null);

  return (
    <>
      <CalculadoraCDBInputCard setResults={setResults} />
      {results && <CalculadoraCDBResponse results={results} />}
    </>
  );
}
